/**
 * Build-identity check for refresh. Every build stamps a unique hash
 * (next.config `env.BUILD_HASH`, tied to the precache revision). `BUILD_HASH`
 * is inlined into this running bundle at build time; `/api/build` reports the
 * hash of whatever build the server is currently serving. Comparing the two
 * tells a refresh whether it needs to pull the whole app (new assets) or can
 * just refetch data in place — no white-flash reload when only data changed.
 */

/** The hash baked into THIS running bundle at build time. */
export const BUILD_HASH = process.env.BUILD_HASH ?? "";

/** True if the server is serving a newer build than the one running here.
 * Never throws; a failed/uncertain probe returns false (treat as "same build"
 * → data-only refresh) so a flaky network can't force a needless reload. */
export async function isNewBuildAvailable(): Promise<boolean> {
  try {
    const r = await fetch("/api/build", { cache: "no-store" });
    if (!r.ok) return false;
    const { hash } = (await r.json()) as { hash?: string };
    return !!hash && !!BUILD_HASH && hash !== BUILD_HASH;
  } catch {
    return false;
  }
}
